var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0417 15.0132C24.1765 12.8784 24.8169 9.81576 23.9659 7.12311C23.8833 6.8584 23.5432 6.78012 23.3468 6.97652L19.053 11.2702C18.3343 11.989 17.1673 11.989 16.4486 11.2702L14.775 9.59659C14.0563 8.87789 14.0563 7.71088 14.775 6.99217L19.0915 2.67567C19.2864 2.4807 19.211 2.1434 18.9491 2.05801C16.2408 1.17137 13.1426 1.80469 10.9879 3.95938C8.68518 6.26208 8.12018 9.64498 9.29288 12.4771L2.55128 19.2187C1.37004 20.3999 1.37004 22.3155 2.55128 23.4968C3.73252 24.678 5.64812 24.678 6.82936 23.4968L13.5895 16.7367C16.4088 17.8738 19.7561 17.2988 22.0417 15.0132Z",
    stroke: "#102D3E",
    strokeWidth: 2.01,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.733481b7ca9cddbe08d9f212c69cfadb.svg";
export { ForwardRef as ReactComponent };